import { StreamActions } from '@hotwired/turbo'

StreamActions.redirect = function () {
  Turbo.visit(this.target, { action: 'replace' })
}

StreamActions.redirect_to = function () {
  Turbo.visit(this.target, { action: 'advance' })
}

StreamActions.post_removed = function () {
  const groupElement = document.getElementById(this.target)?.closest(".repost_list_frame")
  if (!groupElement) return;
  const items = groupElement?.querySelectorAll(".item");

  if (items.length == 2) {
    items?.forEach(item => {
      item.querySelector(".counter").remove()
      item.querySelector(".with-child").remove()
    });
    return;
  }

  items?.forEach(item => {
    item.querySelector(".counter").dataset.total = items.length - 1;
  });
}
